import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useCapabilities } from '@/hooks/useCapabilities';

interface CapabilitySelectorProps {
  selectedCapabilityId: string | null;
  onCapabilitySelect: (capabilityId: string | null) => void;
  disabled?: boolean;
}

export function CapabilitySelector({
  selectedCapabilityId,
  onCapabilitySelect,
  disabled = false,
}: CapabilitySelectorProps) {
  const { capabilities, isLoading } = useCapabilities();

  const handleCapabilityChange = (capabilityId: string) => {
    onCapabilitySelect(capabilityId);
  };

  return (
    <div className="space-y-2">
      <Label>Capability</Label>
      <Select
        value={selectedCapabilityId || ''}
        onValueChange={handleCapabilityChange}
        disabled={disabled || isLoading}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select capability..." />
        </SelectTrigger>
        <SelectContent>
          {capabilities.map((capability) => (
            <SelectItem key={capability.id} value={capability.id}>
              {capability.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
